// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9097L11.5 20.0908V10H14.5V5.09051L9.5 2.1377V18.9097Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2.50012V10H16.5V4.76744L22 2.50012Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22.498 11.9976H13.498V17.6312C13.498 18.6442 14.0093 19.5887 14.8573 20.1428L17.998 22.1945L21.1388 20.1428C21.9868 19.5887 22.498 18.6442 22.498 17.6312V11.9976Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-safety-filled')
export default class MapSafetyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-safety-filled',
    }
  }
}
